<template>
  <form-field>
    <b-radio-button
      v-for="item in items"
      :key="item.value"
      v-model="radioGroup"
      :native-value="item.value"
      type="is-light"
      size="is-small"
      @input="handleInput"
      :expanded="expanded"
      :class="radioClass"
    >
      {{ item.label }}
    </b-radio-button>
  </form-field>
</template>

<script>
export default {
  name: "FormFieldRadioButtons",
  props: {
    value: {
      type: String|Number,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    expanded: {
      type: Boolean,
      default: false
    },
    radioClass: String
  },
  data() {
    return {
      radioGroup: this.value
    }
  },
  watch: {
    value() {
      this.radioGroup = this.value;
    },
  },
  methods: {
    handleInput(val) {
      this.$emit('change', val);
    },
  }
}
</script>
